import { jsx } from "panel";
import { selx } from "clsx";
import { SectionEl } from "common/components/section";
import { SelectTheme } from "common/components/select/constants";
import { SelectEl } from "common/components/select";
import { TooltipEl } from "common/components/tooltip";
import { BucketSizeEl } from "common/widgets/bucket-sizes";
import { SvgIconEl } from "common/components/svg-icon";
import { mpColors } from "common/util/colors";
import { Directions } from "common/components/drop-menu/types";
import { ButtonSize } from "common/components/button/constants";
import { DisplaySize, Placement } from "common/components/tooltip/types";
import { SwitchEl } from "common/components/switch";
import { getCurrentMoment } from "common/util/date";
import { TimeUnit } from "common/widgets/date-range-picker/models/types";
import { RetentionAlignmentType } from "common/report/retention/util/types";
import { CUSTOM_RETENTION_UNIT } from "./constants";
import styles from "./index.module.styl";
const commonTooltipAttrs = {
  size: DisplaySize.Small
};
const CustomBucket = ({
  customRetentionUnitSelected,
  bucketSizes,
  retentionUnit,
  onApplyCustom,
  onCancelCustom
}) => {
  return /* @__PURE__ */ jsx(null, null, customRetentionUnitSelected && /* @__PURE__ */ jsx(TooltipEl, {
    attrs: { text: `Returning users on days: ${bucketSizes}` }
  }), customRetentionUnitSelected && /* @__PURE__ */ jsx(BucketSizeEl, {
    sel: selx(styles.bucketSizes),
    attrs: {
      header: `Custom Retention`,
      "bucket-unit": retentionUnit,
      "bucket-sizes": bucketSizes
    },
    on: {
      apply: onApplyCustom,
      cancel: onCancelCustom
    }
  }));
};
export function template() {
  var _a, _b;
  const dateFormat = `MMM DD`;
  const timezone = (_b = (_a = this.getContext(`currentProject`).get()) == null ? void 0 : _a.value) == null ? void 0 : _b.timezone;
  const today = getCurrentMoment({ timezone }).format(dateFormat);
  const tomorrow = getCurrentMoment({ timezone }).add(1, `days`).format(dateFormat);
  const bucketLength = this.attr(`bucket-sizes`).length;
  const selectedRetentionUnitValue = bucketLength !== 0 ? CUSTOM_RETENTION_UNIT : this.attr(`retention-unit`);
  return /* @__PURE__ */ jsx(SectionEl, {
    sel: selx(styles.section),
    attrs: {
      "header-title": `Retention Criteria`,
      "is-container": true,
      "non-collapsible": true
    }
  }, /* @__PURE__ */ jsx(SelectEl, {
    sel: selx(styles.select, styles.advancedMenu),
    attrs: {
      slot: `actions`,
      theme: SelectTheme.Tertiary,
      "always-show-caret": true,
      "selected-option": `Advanced`,
      "menu-alignment": Directions.Right,
      size: ButtonSize.Small,
      tooltip: { placement: Placement.Right },
      "experimental-positioning": true,
      "menu-width": 185
    },
    props: {
      sections: [
        {
          items: [
            {
              label: `Group by date`,
              tooltip: {
                placement: Placement.Top,
                "max-width": `185px`,
                text: `Enable calendar date intervals instead of the default rolling intervals.
E.g. ${today}, ${tomorrow} instead of Day 1, Day 2`
              },
              actionsRenderer: () => /* @__PURE__ */ jsx(SwitchEl, {
                attrs: {
                  on: this.attr(`retention-alignment-type`) === RetentionAlignmentType.IntervalStart
                },
                on: {
                  change: this.handleToggleRetentionAlignment
                }
              })
            }
          ]
        }
      ]
    },
    on: {
      change: this.handleAdvancedMenuChange
    }
  }), /* @__PURE__ */ jsx("div", {
    sel: selx(styles.retentionCriteria)
  }, /* @__PURE__ */ jsx("div", {
    sel: selx(styles.iconWrapper)
  }, /* @__PURE__ */ jsx(SvgIconEl, {
    attrs: { icon: `stop-watch`, color: mpColors[`$gray3`] }
  })), /* @__PURE__ */ jsx(SelectEl, {
    sel: selx(styles.select, styles.methodSelect),
    attrs: {
      sections: [
        {
          items: this.getRetentionUnboundedOptions()
        }
      ],
      "menu-width": 190,
      theme: SelectTheme.Tertiary
    },
    on: { change: this.handleChangeCountingMethodSelector }
  }), /* @__PURE__ */ jsx(SelectEl, {
    sel: selx(styles.select, styles.unitSelect),
    attrs: {
      elref: `retUnitSelector`,
      sections: [
        {
          items: [
            {
              value: TimeUnit.Day,
              isSelected: selectedRetentionUnitValue === TimeUnit.Day,
              label: `Day`,
              tooltip: {
                text: `Calculate users that came back in day intervals`,
                ...commonTooltipAttrs
              }
            },
            {
              value: TimeUnit.Week,
              isSelected: selectedRetentionUnitValue === TimeUnit.Week,
              label: `Week`,
              tooltip: {
                text: `Calculate users that came back in week intervals`,
                ...commonTooltipAttrs
              }
            },
            {
              value: TimeUnit.Month,
              isSelected: selectedRetentionUnitValue === TimeUnit.Month,
              label: `Month`,
              tooltip: {
                text: `Calculate users that came back in month intervals`,
                ...commonTooltipAttrs
              }
            },
            {
              value: CUSTOM_RETENTION_UNIT,
              isSelected: selectedRetentionUnitValue === CUSTOM_RETENTION_UNIT,
              label: `Custom`,
              tooltip: {
                text: `Select custom intervals`,
                ...commonTooltipAttrs
              }
            }
          ]
        }
      ],
      label: this.getLabel(
        this.attr(`bucket-sizes`),
        this.attr(`retention-unit`),
        this.attr(`retention-alignment-type`)
      ),
      theme: SelectTheme.Tertiary,
      tooltip: this.getUnitSelectorTooltip()
    },
    on: { change: this.handleChangeUnitSelector }
  }), /* @__PURE__ */ jsx(CustomBucket, {
    customRetentionUnitSelected: this.state.customRetentionUnitSelected,
    bucketSizes: this.attr(`bucket-sizes`),
    retentionUnit: this.attr(`retention-unit`),
    onApplyCustom: this.handleApplyCustom,
    onCancelCustom: this.handleCancelCustom
  })));
}
